export default __webpack_public_path__ + "static/media/girl10.aef074d9.svg";